export const USER_ACTIONS_EMPTY_MESSAGE =
  'На данный момент от вас ничего не требуется. Мы будем отслеживать поставки и сообщим, если ваше участие станет необходимым.';

export const USER_ACTIONS_UNAVAILABLE_MESSAGE = 'Действия недоступны';